import { bulkSubscribe, bulkSubscribeSingle } from "@/utils/modelState";
import { isReservationExistingPerson, setupPersonCleanup } from "./model.ReservationPerson";
import { hydrateReservationQuote } from "./model.ReservationQuotes";
import type { ModelContext } from "./model.context";
import { subscribeDates } from './model.datesAndProfiles';
import { hydrateCalculatedPrice, hydratePeople, hydrateRoomBlockDatesContainer } from './model.hydration';
import { updateAmountDueTotal, updateAmountPayableTotal, updateCanRelease } from './model.roomsAndTotals';
export function initializeModel2(context: ModelContext) {
    bulkSubscribe(context.reservation.ProgramBookings, [i => i.CalculatedPrice], () => updateAmountPayableTotal(context.reservation));
    updateAmountPayableTotal(context.reservation);
    context.reservation.AmountPayableTotal.subscribe(() => updateAmountDueTotal(context.reservation));
    context.reservation.Payments.subscribe(() => updateAmountDueTotal(context.reservation));
    context.reservation.Refunds.subscribe(() => updateAmountDueTotal(context.reservation));
    context.reservation.PosItems.subscribe(() => { updateAmountDueTotal(context.reservation); });
    updateAmountDueTotal(context.reservation);
    updateCanRelease(context.reservation);
    hydrateRoomBlockDatesContainer(context.reservation);
    //hydrateNoShow(reservation);
    hydrateCalculatedPrice(context.reservation);
    // auto populate programs/rooms person when setting reservation person
    context.reservation.Person.subscribe(() => {
        if (context.reservation.Person.value &&
            isReservationExistingPerson(context.reservation.Person.value)) {
            //reservation.RoomBookings.toArray().forEach(rb => {
            //    if (rb.People.toArray().length === 0) {
            //        rb.People.add({
            //            ReservationRoomPersonId: uuidv4(),
            //            Person: modelState(reservation.Person.value),
            //            IsDirty: modelState(true)
            //        });
            //    }
            //});
            //reservation.ProgramBookings.toArray().forEach(pb => {
            //    const programPeople = pb.People.toArray();
            //    if (programPeople.length === 0) {
            //        pb.People.add({
            //            ReservationProgramPersonId: uuidv4(),
            //            Person: modelState(reservation.Person.value),
            //            IsDirty: modelState(true)
            //        });
            //    } else if (programPeople.length === 1) {
            //        const programFirstPerson = programPeople[0];
            //        if (!programFirstPerson.Person.value) {
            //            programFirstPerson.Person.setValue(reservation.Person.value);
            //        }
            //    }
            //});
        }
    });
    hydrateReservationQuote(context.reservation);
    subscribeDates(context.reservation);
    bulkSubscribeSingle(context.reservation.RoomBookings, rb => rb.CheckIn, (rb, prevValue) => {
        // Don't propagate to people if this room change was triggered by a person extension
        if ((rb as any)._isPersonTriggeredExtension)
            return;
        rb.People.toArray().forEach(p => {
            if (p.CheckIn.value.getTime() <= prevValue.getTime()) {
                p.CheckIn.setValue(rb.CheckIn.value);
            }
        });
    });
    bulkSubscribeSingle(context.reservation.RoomBookings, rb => rb.CheckOut, (rb, prevValue) => {
        // Don't propagate to people if this room change was triggered by a person extension
        if ((rb as any)._isPersonTriggeredExtension)
            return;
        rb.People.toArray().forEach(p => {
            if (p.CheckOut.value.getTime() >= prevValue.getTime()) {
                p.CheckOut.setValue(rb.CheckOut.value);
            }
        });
    });
    context.reservation.RoomBookings.subscribe(() => {
        const allRoomsAvailable = context.reservation.RoomBookings.toArray().every(rb => rb.AvailabilityCheckResult.value.IsAvailable || rb.NoShow.value === true);
        context.reservation.AreAllRoomsAvailable.setValue(allRoomsAvailable);
    });
    bulkSubscribe(context.reservation.RoomBookings, [
        rb => rb.AvailabilityCheckResult,
        rb => rb.NoShow
    ], () => {
        const allRoomsAvailable = context.reservation.RoomBookings.toArray().every(rb => rb.AvailabilityCheckResult.value.IsAvailable || rb.NoShow.value === true);
        context.reservation.AreAllRoomsAvailable.setValue(allRoomsAvailable);
    });
    context.reservation.ProgramBookings.subscribe(() => {
        const allProgramsAvailable = context.reservation.ProgramBookings.toArray().every(pb => pb.AvailabilityCheckResult.value.IsAvailable || pb.NoShow.value === true || pb.AllowOverbooking.value === true);
        context.reservation.AreAllProgramsAvailable.setValue(allProgramsAvailable);
    });
    bulkSubscribe(context.reservation.ProgramBookings, [
        pb => pb.AvailabilityCheckResult,
        pb => pb.NoShow,
        pb => pb.AllowOverbooking
    ], () => {
        const allProgramsAvailable = context.reservation.ProgramBookings.toArray().every(pb => pb.AvailabilityCheckResult.value.IsAvailable || pb.NoShow.value === true || pb.AllowOverbooking.value === true);
        context.reservation.AreAllProgramsAvailable.setValue(allProgramsAvailable);
    });
    hydratePeople(context.reservation);
    // Setup automatic cleanup of orphaned new people
    setupPersonCleanup(context.reservation);
    // Set up error callback after reservation is created
    (context.personCache as any).errorCallback = (error: string) => {
        context.reservation.LoadingError.setValue(error);
        context.reservation.HasCriticalError.setValue(true);
    };
}
